(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const postToPlayer = (iframe, type, play) => {
    if (!iframe?.contentWindow) return;
    if (type === 'youtube') {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: play ? 'playVideo' : 'pauseVideo',
        args: [],
      }), '*');
      return;
    }
    if (type === 'vimeo') {
      iframe.contentWindow.postMessage(JSON.stringify({ method: play ? 'play' : 'pause' }), '*');
    }
  };

  const loadIframe = (iframe, { forceAutoplay = false } = {}) => {
    if (!iframe || iframe.getAttribute('src') || !iframe.dataset.src) return;
    let src = iframe.dataset.src;
    if (forceAutoplay) {
      const url = new URL(src);
      url.searchParams.set('autoplay', '1');
      src = url.toString();
    }
    iframe.src = src;
  };

  document.querySelectorAll('[data-video-promo]').forEach((root) => {
    if (root.dataset.videoReady === 'true') return;
    root.dataset.videoReady = 'true';

    const video = root.querySelector('video');
    const iframe = root.querySelector('iframe');
    const playBtn = root.querySelector('[data-video-play]');
    const muteBtn = root.querySelector('[data-video-mute]');
    const poster = root.querySelector('.video-with-text__poster');
    const type = root.dataset.videoType;
    const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
    const playInView = root.dataset.playInView === 'true';

    const playMedia = () => {
      if (video) {
        video.play().catch(() => {});
      }
      if (iframe) {
        loadIframe(iframe, { forceAutoplay: Boolean(playBtn) });
        postToPlayer(iframe, type, true);
      }
      if (playBtn) playBtn.hidden = true;
      if (poster) poster.hidden = true;
    };

    const pauseMedia = () => {
      if (video) video.pause();
      if (iframe) postToPlayer(iframe, type, false);
    };

    if (reduceMotion && video) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    playBtn?.addEventListener('click', playMedia);

    muteBtn?.addEventListener('click', () => {
      if (!video) return;
      video.muted = !video.muted;
      muteBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      muteBtn.setAttribute(
        'aria-label',
        video.muted ? (muteBtn.dataset.unmuteLabel || 'Unmute video') : (muteBtn.dataset.muteLabel || 'Mute video')
      );
      const mutedIcon = muteBtn.querySelector('[data-icon-muted]');
      const unmutedIcon = muteBtn.querySelector('[data-icon-unmuted]');
      if (mutedIcon) mutedIcon.hidden = !video.muted;
      if (unmutedIcon) unmutedIcon.hidden = video.muted;
    });

    video?.addEventListener('play', () => {
      if (playBtn) playBtn.hidden = true;
    });

    if (playInView && (video || iframe) && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (autoplay) playMedia();
            else if (iframe && !playBtn) loadIframe(iframe);
          } else {
            pauseMedia();
          }
        });
      }, { threshold: 0.35 });
      observer.observe(root);
    } else if (autoplay) {
      playMedia();
    }
  });
})();
